"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _ThemeService = require("../common/ThemeService.js");
var _PlayerLevel = _interopRequireDefault(require("./PlayerLevel.js"));
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); Object.defineProperty(subClass, "prototype", { writable: false }); if (superClass) _setPrototypeOf(subClass, superClass); }
function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf ? Object.setPrototypeOf.bind() : function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }
function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }
function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } else if (call !== void 0) { throw new TypeError("Derived constructors may only return object or undefined"); } return _assertThisInitialized(self); }
function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }
function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf.bind() : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }
// import { Line } from 'rc-progress';

var domain = process.env.REACT_APP_DOMAIN;
var ReportSummary = /*#__PURE__*/function (_Component) {
  _inherits(ReportSummary, _Component);
  var _super = _createSuper(ReportSummary);
  function ReportSummary(props) {
    var _this;
    _classCallCheck(this, ReportSummary);
    _this = _super.call(this, props);
    _this.componentDidMount = function () {
      _this.setState({
        banner_url: (0, _ThemeService.getImage)("https://".concat(_this.props.domain, "/images/social-banners/"), "/".concat(_this.props.gameType, "/").concat(_this.props.level.toLowerCase().replace(' ', '-'), "-").concat(_this.props.stars, ".jpg"))
      });
    };
    _this.shareModal_close = function () {
      return _this.setState({
        shareDialogOpen: false
      });
    };
    _this.shareModal_open = function () {
      var _this$state = _this.state,
        banner_url = _this$state.banner_url,
        title = _this$state.title,
        description = _this$state.description,
        brandLoggedInType = _this$state.brandLoggedInType;
      var _this$props = _this.props,
        gameType = _this$props.gameType,
        level = _this$props.level,
        stars = _this$props.stars;
      _this.props.getShareId({
        type: 'ReportCard',
        // banner_url: `https://${this.props.domain}/images/social-banners/${localStorage.getItem("loggedInType")==="Danskespil"? "Danskespil" : "PartyPoker"}/${this.props.gameType}/${this.props.level.toLowerCase().replace(' ', '-')}-${this.props.stars}.jpg`,
        banner_url: (0, _ThemeService.getImage)("https://".concat(_this.props.domain, "/images/social-banners/"), "/".concat(_this.props.gameType, "/").concat(_this.props.level.toLowerCase().replace(' ', '-'), "-").concat(_this.props.stars, ".jpg")),
        title: title,
        description: description,
        brandLoggedInType: brandLoggedInType,
        hit_attribute1: gameType,
        hit_attribute2: level,
        hit_attribute3: stars,
        hit_attribute4: localStorage.getItem('username'),
        gameType: gameType,
        level: level,
        stars: stars
      });
    };
    _this.state = {
      open: false,
      shareDialogOpen: false,
      medalList: [],
      starListElem: [],
      sharedLink: "",
      banner_url: "",
      brandLoggedInType: localStorage.getItem('loggedInType'),
      title: "Find out your poker skill level for free now!",
      description: "MyGame, partypoker's free coach's here to take your game to next level"
    };
    return _this;
  }
  _createClass(ReportSummary, [{
    key: "render",
    value: function render() {
      var _this2 = this;
      var starListElem = [];
      var props = this.props;
      var _this$props2 = this.props,
        medalUrl = _this$props2.medalUrl,
        medalsDetails = _this$props2.medalsDetails,
        starsDetails = _this$props2.starsDetails,
        score = _this$props2.score,
        level = _this$props2.level,
        noOfHands = _this$props2.noOfHands,
        stars = _this$props2.stars,
        gameType = _this$props2.gameType;
      var showModal = this.state.open ? 'displayBlock' : 'displayNone';
      var showShareModal = this.state.shareDialogOpen ? 'displayBlock' : 'displayNone';
      var banner_url = this.state.banner_url;
      starsDetails.map(function (starObj, i) {
        starListElem.push( /*#__PURE__*/_react["default"].createElement("div", {
          className: "exp-level-div"
        }, /*#__PURE__*/_react["default"].createElement("span", {
          className: "exp-level-span",
          key: "key" + i
        }, "Hands: ".concat(starObj.min_hand, " ").concat(starObj.max_hand ? "- ".concat(starObj.max_hand) : '')), /*#__PURE__*/_react["default"].createElement("img", {
          className: "expStars",
          key: i,
          style: {
            height: 30,
            width: 130,
            marginLeft: "-5px"
          },
          src: "".concat((0, _ThemeService.getImage)("/images/Stars/", "/Star_".concat(starObj.star, ".png")))
        })));
      });
      return /*#__PURE__*/_react["default"].createElement("div", {
        className: "skill_details_row"
      }, /*#__PURE__*/_react["default"].createElement(_PlayerLevel["default"], {
        brandLoggedInType: this.state.brandLoggedInType,
        domain: props.domain,
        showModal: showModal,
        medalsDetails: medalsDetails,
        starListElem: starListElem,
        closeLevelInfo: function closeLevelInfo() {
          _this2.setState({
            open: false
          });
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "player-level"
      }, /*#__PURE__*/_react["default"].createElement("img", {
        className: "medalCss",
        "data-e2e": "medalImg",
        src: this.props.medalUrl,
        style: {
          height: "146px",
          width: "146px"
        }
      }), /*#__PURE__*/_react["default"].createElement("div", {
        className: "stats"
      }, /*#__PURE__*/_react["default"].createElement("div", {
        className: "skillLevel"
      }, /*#__PURE__*/_react["default"].createElement("b", null, this.props.i18next.t("lable.skillLevel"), ":"), " ", /*#__PURE__*/_react["default"].createElement("span", {
        style: {
          fontFamily: "Roboto",
          fontWeight: 'bold'
        }
      }, this.props.level)), /*#__PURE__*/_react["default"].createElement("div", {
        className: "overallScore",
        "data-e2e": "overallScore",
        style: {
          fontFamily: "Roboto",
          fontSize: "16px",
          marginTop: "-2px",
          fontWeight: 400,
          textAlign: 'centre'
        }
      }, this.props.i18next.t("lable.overallScore") + ": ", this.props.score ? this.props.score : '', "%"), /*#__PURE__*/_react["default"].createElement("div", {
        className: "handsPlayed",
        "data-e2e": "handsPlayed",
        style: {
          fontFamily: "Roboto",
          fontSize: "16px",
          marginTop: "-2px",
          marginBottom: "3px",
          fontWeight: 400,
          textAlign: 'centre'
        }
      }, this.props.i18next.t("lable.handsPlayed") + ": ", this.props.noOfHands ? this.props.noOfHands : ''), /*#__PURE__*/_react["default"].createElement("div", {
        className: "actionButtons"
      }, /*#__PURE__*/_react["default"].createElement("button", {
        "data-e2e": "shareLevelReportCard",
        className: "mg-btn grey btnHalo shareLevel",
        onClick: this.shareModal_open
      }, this.props.i18next.t("lable.shareLevel")), /*#__PURE__*/_react["default"].createElement("button", {
        className: "levelInfo mg-btn grey btnHalo",
        "data-e2e": "levelInfo",
        onClick: function onClick() {
          _this2.setState({
            open: true
          });
        }
      }, this.props.i18next.t("lable.levelInfo"))), this.props.isLiveview ? /*#__PURE__*/_react["default"].createElement("button", {
        onClick: function onClick(e) {
          e.preventDefault();
          _this2.props.onOpenMyGameClick();
        },
        className: "openMyGameBtnCss"
      }, this.props.i18next.t("lable.openMygame")) : null)));
    }
  }]);
  return ReportSummary;
}(_react.Component);
var _default = ReportSummary;
exports["default"] = _default;


/*****************
 ** WEBPACK FOOTER
 ** ./~/mygame-components/dist/ReportCards/ReportSummary.js
 ** module id = 2397
 ** module chunks = 0
 **/